<div *ngIf="loginDisplay" class="login-form">
    <form>
        <img class="logo mb-4" src="./assets/img/logo_tenaris.png" alt="Tenaris">
        <div class="form-group">
            <label for="selectedLocation">{{ 'login.location' | translate }}</label>
            <select class="form-control" id="selectedLocation" [(ngModel)]="selectedLocation" name="selectedLocation">
                <option [ngValue]="opt" *ngFor="let opt of locationRoles">{{opt.LocationName}} ({{opt.RoleName}})</option>
            </select>
        </div>
        <div class="form-group btn-container pt-4">
            <button [disabled]="loading" (click)="profile(selectedLocation.LocationId, selectedLocation.RoleId, selectedLocation.Id)" class="btn btn-primary btn-block"
                type="button">{{ 'login.confirm' | translate }}
                <div *ngIf="loading" class="spinner-border spinner-border-sm text-secondary" role="status">
                    <!-- <span class="sr-only">Loading...</span> -->
                </div>
            </button>
        </div>
    </form>
</div>